import React from 'react'
import styled from 'styled-components'
import Modal from '../components/modal'
import DraggableContainer from './draggableContainer'
import { Tooltip } from 'react-tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronCircleLeft, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons'

const Table = styled.table`
  width: 100%;
  margin: auto;
  border-collapse: separate;
  border-spacing: 0;
  text-align: left;
  color: ${props => props.theme.tableFg};
`

const TableRow = styled.tr`
  height: 50px;

  tbody &:hover td {
    background-color: ${props => props.theme.tableRowRightHover};
  }

  tbody &:hover th {
    background-color: ${props => props.theme.tableRowLeftHover};
  }
`

const TableHeader = styled.th`
  text-align: center;
  padding: 0.8rem 0.6rem;
  border-right: 1px solid ${props => props.theme.tableDarkBorder};
  border-bottom: 1px solid ${props => props.theme.tableDarkBorder};
  position: sticky;
  background-color: ${props => props.theme.tableBg};
  vertical-align: bottom;
  img {
    max-width: 50px;
    max-height: 50px;
    cursor: help;
  }
  .react-tooltip {
    z-index:9999999999999;
    padding: 4px;
    font-size: 10px;
    max-width: 70px;
  }
`

const TaskNameCell = styled(TableHeader)`
  text-align: ${props => props.centered ? 'center' : 'left'};
  min-width: ${props => props.centered ? '50px' : '250px'};
  border-right: 1px solid ${props => props.theme.tableDarkBorder};
  cursor: ${props => props.clickable ? 'pointer' : 'default'};

  @media (min-width: 600px) {
    left: 0;
  }
  
  img {
    max-width: 50px;
    max-height: 50px;
    margin-right: 8px;
    vertical-align: middle;
  }
`

const QuarterCell = styled(TableHeader)`
  min-width: 60px;
  top: 0;
`

const CornerCell = styled(TableHeader)`
  // text-align: right;
  padding-right: 1rem;
  z-index: 99;
  top: 0;
  @media (min-width: 600px) {
    left: 0;
  }
  
  svg {
    font-size: 1.4rem;
    color: ${props => props.theme.tableFg};
    cursor: pointer;
  }
  
  svg:hover {
    color: ${props => props.theme.tableRowLeftHover};
  }

  text-align: center;
  font-size: 43px;
  font-family: sans-serif;
  font-weight: lighter;
  line-height: 38px;
  // color: rgba(224, 91, 55, 0.8); 
  color: #e05b3715;
  padding-left: 0;
  padding-right: 0;
  letter-spacing: .25rem;
  vertical-align: top;

  span {
    font-size: 34px;
    letter-spacing: -0.07rem;
    line-height: 50px;
  }
`
const TableCell = styled.td`
  padding: 0;
  background-color: ${props => props.theme.taskBg};
  border-bottom: 1px solid ${props => props.theme.tableLightBorder};
`

const TableTaskRect = styled.div`
  width: 100%;
  height: 30px;
  background-color: ${props => (props.completed ? props.theme.taskCompleteColor : props.theme.taskColor)};
  border-radius: 5px;
`

const TableTopHeader = ({config, collapseNames, onCollapseChange}) => {
    const elements = []
    let year = config.settings.startYear
    let q = config.settings.startQuarter
    let iconyear = 0;
    for(let i = 1; i <= config.settings.quarterLength; i++) {
        let y = config.settings.headerIcons[iconyear] 
        let alt = config.settings.altIcons[iconyear]
        elements.push({ id: i, year, q, y, alt})
        q++;
        iconyear++;
        if(q > 4) {
            year++
            q = 1
        }
    } 
    return(
        <thead>
            <TableRow>
                <CornerCell>
                <span>DEVELOPMENT</span><br/>
                ROADMAP
                </CornerCell>
                {elements.map(item => <QuarterCell key={item.id}>       
                  {item.y && <img src={item.y} alt={item.alt} data-tooltip-id={"t"+item.id} data-tooltip-content={item.alt} data-tooltip-place="top" data-tooltip-offset="-10"/>}
                  {item.y && <Tooltip id={"t"+item.id} />}
                  {item.y && <br/>}
                  {item.year}<br/>Q{item.q}</QuarterCell>)}
            </TableRow>
        </thead>
    )
}

      /*
      <FontAwesomeIcon
          icon={collapseNames ? faChevronCircleRight : faChevronCircleLeft}
          onClick={() => onCollapseChange(!collapseNames)}/>
      */
                        
const calculateLeftOffset = (task, config) => {
    const taskYear = task.year
    const taskQuarter = task.quarter
    let y = config.settings.startYear
    let q = config.settings.startQuarter
    for(let i = 0; i <= config.settings.quarterLength; i++) {
        if(taskYear === y && taskQuarter === q) return i
        q++;
        if(q > 4) {
            y++
            q = 1
        }
    }
    return 1
}

const calculateRightOffset = (task, config) => {
    const offset = calculateLeftOffset(task, config) + task.quarterLength
    return config.settings.quarterLength - offset
}

const TaskRow = ({task, config, collapseTaskNames, onTaskClick}) => {
    return(
        <>
            <TableRow style={{height: task.name.length<=1 ? '25px' : '50px'}}>
                <TaskNameCell style={{background: task.separ != null ? '#e05b37' : ''}} onClick={() => {if(task.description) onTaskClick(task)}}
                              clickable={task.description != null} centered={collapseTaskNames}>
                    {task.icon && <img src={task.icon} alt={task.name}/>}
                    {!collapseTaskNames && <span style={{color: task.separ != null ? '#FFFFFF' : ''}}>{task.name}</span>}
                </TaskNameCell>
                <TableCell colSpan={calculateLeftOffset(task, config)} style={{display: calculateLeftOffset(task, config)<=0 ? 'none' : 'table-cell'}} />
                <TableCell colSpan={task.quarterLength} style={{display: task.separ != null ? 'none' : 'table-cell'}}> <TableTaskRect completed={task.completed}/></TableCell>
                <TableCell colSpan={calculateRightOffset(task, config)}/>
            </TableRow>
        </>
    )
}

const TaskList = (props) => (
    <tbody> 
        {props.config.tasks.map(task => <TaskRow key={task.name} task={task} {...props} />)}
    </tbody>
)

const Scrollright = () => {
  setTimeout(() => {
    window.scrollTo({
      left: window.outerWidth,
      behavior: 'smooth',
    });
  }, 0)
}    

const Roadmap = ({config}) => {
    const [taskModal, setTaskModal] = React.useState(null)
    const [collapseTaskNames, setCollapseTaskNames] = React.useState(false)

    return(
        <DraggableContainer topBarOffset={config.project.topBar != null}>
            <Table>
                <TableTopHeader config={config} collapseNames={collapseTaskNames} onCollapseChange={setCollapseTaskNames}/>
                <TaskList config={config} collapseTaskNames={collapseTaskNames} onTaskClick={task => setTaskModal(task)}/>
            </Table>
            {
                taskModal
                &&
                <Modal onClose={() => setTaskModal(null)}
                       title={taskModal.name}
                       text={taskModal.description}
                       task={taskModal}
                       links={taskModal.links}/>
            }
        </DraggableContainer>
    )
}

export default Roadmap
